// auth.guard.ts
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from 'common-libs';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private _authService: AuthService, private _router: Router) {}
  moduleAccess: any = [];
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
      let router = route.data['module'];
      if(router)
      {
        if (this._authService.getAccessToken() == '') {
          this._router.navigate(['/auth/signin']);
        }

        if (this._authService.isTokenExpired(this._authService.getAccessToken())) {
          this._router.navigate(['/auth/signin']);
        }
        if (localStorage?.getItem('moduleList')) {
          let modulePermission = JSON.parse(
            localStorage.getItem('moduleList') ?? ''
          );
          if (modulePermission?.length) {
            this.moduleAccess = modulePermission?.filter((item: any) =>
              router.toLowerCase() == item?.name.toLowerCase())
            if (this.moduleAccess.length == 0) {
              this._router.navigate(['auth/error']);
            }
          }
        }
      }
      if (this._authService.getAccessToken()) {
        return true;
      } else {
        this._router.navigate(['/auth/signin']);
        return false;
      }
  }
}
